import { RawAppSyncSubscriptionClient } from "./RawAppSyncSubscriptionClient";

export interface ApolloClientOptions {
  graphqlEndpoint: string;
  realtimeEndpoint: string;
  graphQLHost: string;
}

export async function createApolloClient({
  graphqlEndpoint,
  realtimeEndpoint,
  graphQLHost,
}: ApolloClientOptions): Promise<RawAppSyncSubscriptionClient> {
  const client = new RawAppSyncSubscriptionClient({
    graphqlEndpoint,
    realtimeEndpoint,
    graphQLHost,
  });

  try {
    await client.connect();
  } catch (connectError) {
    // The client self-heals from a mid-session drop, but a failed FIRST
    // connect is different: the caller discards the instance, so an
    // orphan would sit there reconnecting to a socket nobody reads.
    // disconnect() marks it intentionally closed and stops that loop.
    client.disconnect();
    throw connectError;
  }
  return client;
}
